import { render, staticRenderFns } from "./VideoPopup.vue?vue&type=template&id=8c009b90"
import script from "./VideoPopup.vue?vue&type=script&lang=js"
export * from "./VideoPopup.vue?vue&type=script&lang=js"
import style0 from "./VideoPopup.vue?vue&type=style&index=0&id=8c009b90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports